// Design tokens — the single source of truth for the redesign.
// Brand hues are pulled verbatim from stain-stingray-mobile's app_colors.dart,
// not invented, so the dashboard and the app read as the same product.
// See docs/redesign/README.md for the reasoning.

export const brand = {
  tealLight: "#08A784", // mobile: new_primary_color — primary.main
  tealDark: "#11998E", // mobile: app_color_primary — primary.dark
  green: "#38EF7D", // mobile: app_color_secondary — secondary.main / accent
};

// Neutral scale anchored at the mobile app's exact text color (grey[900]),
// extended into a full slate-style scale for backgrounds, borders, and
// secondary text.
export const grey = {
  50: "#F8FAFC",
  100: "#F1F5F9",
  200: "#E2E8F0",
  300: "#CBD5E1",
  400: "#94A3B8",
  500: "#64748B",
  600: "#475569",
  700: "#334155",
  800: "#293142",
  900: "#2B3141", // mobile: text_color
};

// Status semantics are deliberately a different palette from the brand accent
// (secondary.main) — brand accent is chrome/gradients, these are form and
// status meaning, and conflating them makes status chips look like branding.
export const semantic = {
  success: "#16A34A",
  warning: "#F59E0B",
  error: "#DC2626",
  info: "#0284C7",
};

export const radius = {
  sm: 8, // buttons, inputs, chips
  md: 10, // theme.shape.borderRadius base
  lg: 16, // cards, dialogs, the page container
  xl: 20, // the sidebar / large surfaces
};

// Soft, low-elevation shadows applied via component overrides (Paper/Card/
// AppBar/Dialog) rather than replacing MUI's theme.shadows[] array wholesale —
// that array is indexed by many components internally, so overriding it
// globally risks changes nobody asked for. Applying shadows at the component
// level is the same visual result with far less blast radius.
export const shadow = {
  sm: "0 1px 2px rgba(15, 23, 42, 0.06)",
  md: "0 2px 8px rgba(15, 23, 42, 0.08)",
  lg: "0 8px 24px rgba(15, 23, 42, 0.12)",
};

export const sidebarWidth = 272;
export const topbarHeight = 64;
